import React, { useCallback, useEffect, useState } from "react";
import styles from "../../../pages/ordermanager/Orders.module.css";
import { useAuth } from "../../context/Auth";
import Button from "../Dealers/Button";
import VerticalDropDown2 from "../FormComponents/VerticalDropDown2";
import { useToast } from "../Toaster/Toaster";
import DeliveryInstructionsModal from "./DeliveryInstructionsModal";

const ConfirmOrder = ({
  handleCloseModal,
  heading,
  centerHeading,
  handleSubmit,
  targetWord,
  loading,
  isManagerAssigned,
  orderManagers,
  handleOpenModal,
  itemDetails,
  shippingType,
  setShippingDetails,
  handleInstructionChange,
  instructions,
  setInstructions,
}) => {
  const { show } = useToast();
  const { mode, designations } = useAuth();
  const [selectedOM, setSelectedOM] = useState();

  const cH = centerHeading?.split(new RegExp(`(${targetWord})`, "gi"));

  const showDropDown =
    (designations.includes("superadmin") ||
      designations.includes("inventorymanager")) &&
    !isManagerAssigned &&
    orderManagers.length !== 0;

  const handleModalSubmit = useCallback(async () => {
    if (showDropDown) {
      if (!selectedOM) {
        show("Select an Order Manager First!", "warning");
      } else {
        await handleSubmit("success", selectedOM?.value);
      }
    } else {
      await handleSubmit("success");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [handleSubmit, selectedOM, showDropDown]);

  const uniqueWarehouses = itemDetails
    .filter((i) => i.warehouse && i.warehouseId)
    .reduce((acc, item) => {
      if (!acc.find((w) => w.warehouseId === item.warehouseId)) {
        acc.push({
          warehouse: item.warehouse,
          warehouseId: item.warehouseId,
        });
      }
      return acc;
    }, []);
    
  const openDeliveryInstructionModal = useCallback(
    (event) => {
      event.preventDefault();
      handleOpenModal(
        <DeliveryInstructionsModal
          mode={mode}
          handleCloseModal={handleCloseModal}
          warehouses={uniqueWarehouses}
          handleSubmit={handleModalSubmit}
          setShippingDetails={setShippingDetails}
          handleInstructionChange={handleInstructionChange}
          instructions={instructions}
          setInstructions={setInstructions}
        />
      );
    },
    [
      handleCloseModal,
      handleInstructionChange,
      handleModalSubmit,
      handleOpenModal,
      instructions,
      mode,
      setInstructions,
      setShippingDetails,
      uniqueWarehouses,
    ]
  );

  // useEffect(() => {
  //   const handleKeyPress = async (event) => {
  //     if (event.key.toLowerCase() === "y") {
  //       handleModalSubmit();
  //     }
  //     if (event.key.toLowerCase() === "n") {
  //       handleCloseModal();
  //     }
  //     if (event.key.toLowerCase() === "i") {
  //       openDeliveryInstructionModal(event);
  //     }
  //   };

  //   window.addEventListener("keydown", handleKeyPress);

  //   return () => {
  //     window.removeEventListener("keydown", handleKeyPress);
  //   };
  // }, [handleCloseModal, handleModalSubmit, openDeliveryInstructionModal]);

  useEffect(() => {
    const handleKeyPress = (event) => {
      const key = event.key.toLowerCase();
      if (key === "y") {
        handleModalSubmit();
      }
      if (key === "n") {
        handleCloseModal();
      }
      if (key === "i") {
        openDeliveryInstructionModal(event);
      }
    };

    window.addEventListener("keyup", handleKeyPress);

    return () => {
      window.removeEventListener("keyup", handleKeyPress);
    };
  }, [handleCloseModal, handleModalSubmit, openDeliveryInstructionModal]);

  const managerOptions = orderManagers.map((manager) => ({
    label: manager.name,
    value: manager.managerId,
  }));

  return (
    <div
      className={styles.confirm_order}
      style={{ backgroundColor: mode ? "#232529" : "#fff" }}
    >
      <p
        className={styles.bold_text}
        style={{ alignSelf: "flex-start", color: mode ? "#ffffff" : "#000" }}
      >
        {heading}
      </p>
      <img src="/assets/updatedAssets/logout_img.png" alt="" />

      {showDropDown ? (
        <p
          className={`${styles.bold_text}`}
          style={{ color: mode ? "#ffffff" : "#000" }}
        >
          Assign an Order Manager to{" "}
          <span style={{ color: "#4164E3" }}>save!</span>
        </p>
      ) : (
        <p
          className={`${styles.bold_text}`}
          style={{ color: mode ? "#ffffff" : "#000" }}
        >
          {cH?.map((part, index) =>
            part?.toLowerCase() === targetWord?.toLowerCase() ? (
              <span key={index} style={{ color: "#FF8000" }}>
                {part}
              </span>
            ) : (
              <span key={index}>{part}</span>
            )
          )}
        </p>
      )}

      {showDropDown && (
        <div className={styles.confirm_order_dd}>
          <VerticalDropDown2
            height={"37px"}
            fontSize={"12px"}
            label={"Select Manager"}
            options={managerOptions}
            dropDownOpen={true}
            onchange={(v) => {
              setSelectedOM(v);
            }}
            value={selectedOM}
          />
        </div>
      )}

      <div className={styles.confirm_order_btns}>
        <div>
          <Button
            buttonText={"Add Instructions"}
            buttonBgColor={"#000000"}
            buttonTextColor={"#ffffff"}
            buttonBorder={"none"}
            buttonClick={openDeliveryInstructionModal}
            tabIndex={-1}
          />
          <p
            className={styles.btn_text}
            style={mode ? { color: "#FFFFFF" } : {}}
          >
            Press - I
          </p>
        </div>

        <div>
          <Button
            buttonText={"No"}
            buttonBgColor={"#000000"}
            buttonTextColor={"#ffffff"}
            buttonBorder={"none"}
            buttonClick={handleCloseModal}
            tabIndex={-1}
          />
          <p
            className={styles.btn_text}
            style={mode ? { color: "#FFFFFF" } : {}}
          >
            Press - N
          </p>
        </div>

        <div>
          <Button
            buttonText={"Yes"}
            buttonBgColor={"#4164E3"}
            buttonTextColor={"#ffffff"}
            buttonBorder={"none"}
            buttonClick={handleModalSubmit}
            tabIndex={-1}
            loading={loading}
          />
          <p
            className={styles.btn_text}
            style={mode ? { color: "#FFFFFF" } : {}}
          >
            Press - Y
          </p>
        </div>
      </div>
    </div>
  );
};

export default ConfirmOrder;
